export default "/assets/79adb49edab2581e.svg"